import { render, staticRenderFns } from "./consumableSurplus.vue?vue&type=template&id=f3553a74&scoped=true"
import script from "./consumableSurplus.vue?vue&type=script&lang=js"
export * from "./consumableSurplus.vue?vue&type=script&lang=js"
import style0 from "./consumableSurplus.vue?vue&type=style&index=0&id=f3553a74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3553a74",
  null
  
)

export default component.exports